import React, { useState, useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, AuthCallback, Navbar, Footer, PlanYourVisitModal, FloatingPlanVisitButton } from "./shared";

import HomePage from "./pages/HomePage";
import AboutPage from "./pages/AboutPage";
import WhoWeArePage from "./pages/WhoWeArePage";
import PillarDetailPage from "./pages/PillarDetailPage";
import MinistriesPage from "./pages/MinistriesPage";
import MediaPage from "./pages/MediaPage";
import EventsPage from "./pages/EventsPage";
import GivePage from "./pages/GivePage";
import ContactPage from "./pages/ContactPage";
import AdminDashboard from "./pages/AdminDashboard";

function AppRouter() {
  const location = useLocation();
  const [planVisitOpen, setPlanVisitOpen] = useState(false);

  // Open the modal when /contact?plan=1 is visited (so the floating button can deep-link)
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    if (params.get("plan") === "1") setPlanVisitOpen(true);
  }, [location.search]);

  if (location.hash?.includes('session_id=')) return <AuthCallback />;

  return (
    <>
      <Navbar />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/who-we-are" element={<WhoWeArePage />} />
        <Route path="/pillars/:slug" element={<PillarDetailPage />} />
        <Route path="/ministries" element={<MinistriesPage />} />
        <Route path="/media" element={<MediaPage />} />
        <Route path="/events" element={<EventsPage />} />
        <Route path="/give" element={<GivePage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/admin" element={<AdminDashboard />} />
      </Routes>
      <FloatingPlanVisitButton onClick={() => setPlanVisitOpen(true)} />
      <PlanYourVisitModal open={planVisitOpen} onClose={() => setPlanVisitOpen(false)} />
      <Footer />
    </>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Toaster position="top-right" richColors />
        <AppRouter />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
